export default __webpack_public_path__ + "static/productbg1-aa5a1ae935d504efe91ef70132255350.png";